import { useNotificationIntegration } from '@/hooks/useNotificationIntegration'

export const useVkNotificationCommunityIntegration = (
  userId: string | number | null | undefined,
  userRole: string | null | undefined,
) => {
  const result = useNotificationIntegration('vkontakte', userId, userRole)

  return {
    status: result.status,
    integrationId: result.integrationId,
    displayHandle: result.displayHandle,
    necessarily: result.necessarily,
  }
}
